var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLowSoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_601",
    "data-name": "Group 601",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1724",
    "data-name": "Rectangle 1724",
    width: 100,
    height: 100,
    fill: "rgba(0,0,0,0)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1755",
    "data-name": "Rectangle 1755",
    width: 60.3,
    height: 48.87,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Watering_Events_Icon",
    "data-name": "Watering Events Icon",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3068",
    "data-name": "Path 3068",
    d: "M50,100a50,50,0,1,1,50-50,50.057,50.057,0,0,1-50,50M50,3.149A46.85,46.85,0,1,0,96.851,50,46.9,46.9,0,0,0,50,3.149",
    transform: "translate(0 0.283)",
    fill: "#164295"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2836",
    "data-name": "Group 2836",
    transform: "translate(1298.733 -412.55)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_631",
    "data-name": "Group 631",
    transform: "translate(-1279.033 439)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3096",
    "data-name": "Path 3096",
    d: "M57.5,48.87H2.8a2.8,2.8,0,0,1-2.8-2.8V2.8A2.8,2.8,0,0,1,2.8,0H57.5a2.805,2.805,0,0,1,2.8,2.8V46.068a2.805,2.805,0,0,1-2.8,2.8M2.8,1.97A.833.833,0,0,0,1.97,2.8V46.068A.833.833,0,0,0,2.8,46.9H57.5a.832.832,0,0,0,.831-.832V2.8A.832.832,0,0,0,57.5,1.97Z",
    transform: "translate(0 0)",
    fill: "#174295"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3097",
    "data-name": "Path 3097",
    d: "M36.2,51.888A3.583,3.583,0,1,1,39.784,48.3,3.588,3.588,0,0,1,36.2,51.888m0-5.2A1.613,1.613,0,1,0,37.813,48.3,1.614,1.614,0,0,0,36.2,46.691",
    transform: "translate(-6.05 -8.296)",
    fill: "#174295"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1746",
    "data-name": "Rectangle 1746",
    width: 12.907,
    height: 1.97,
    transform: "translate(37.293 36.999)",
    fill: "#174295"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1747",
    "data-name": "Rectangle 1747",
    width: 7.094,
    height: 1.97,
    transform: "translate(37.293 41.129)",
    fill: "#174295"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1748",
    "data-name": "Rectangle 1748",
    width: 12.907,
    height: 1.97,
    transform: "translate(10.099 36.999)",
    fill: "#174295"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1749",
    "data-name": "Rectangle 1749",
    width: 7.094,
    height: 1.97,
    transform: "translate(15.912 41.129)",
    fill: "#174295"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3098",
    "data-name": "Path 3098",
    d: "M55.063,4.56H7.123A2.045,2.045,0,0,0,5.081,6.6V32.077a2.045,2.045,0,0,0,2.042,2.042h47.94A2.044,2.044,0,0,0,57.1,32.077V6.6A2.044,2.044,0,0,0,55.063,4.56M37.3,32.149H24.886v-.254c0-3.02,2.784-5.478,6.207-5.478S37.3,28.875,37.3,31.895Zm17.834-.072a.072.072,0,0,1-.071.072H39.271v-.254c0-3.79-3.127-6.922-7.152-7.383l-2.365.044a7.7,7.7,0,0,0-6.839,7.339v.254H7.123a.072.072,0,0,1-.072-.072V6.6a.072.072,0,0,1,.072-.072h47.94a.071.071,0,0,1,.071.072Z",
    transform: "translate(-0.943 -0.846)",
    fill: "#174295"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1750",
    "data-name": "Rectangle 1750",
    width: 2.365,
    height: 4.138,
    transform: "translate(28.968 9.28)",
    fill: "#174295"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1751",
    "data-name": "Rectangle 1751",
    width: 4.138,
    height: 2.365,
    transform: "matrix(0.458, -0.889, 0.889, 0.458, 37.609, 15.011)",
    fill: "#174295"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1752",
    "data-name": "Rectangle 1752",
    width: 2.365,
    height: 4.138,
    transform: "translate(18.692 12.418) rotate(-27.289)",
    fill: "#174295"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1753",
    "data-name": "Rectangle 1753",
    width: 4.138,
    height: 2.365,
    transform: "translate(45.389 19.855) rotate(-45)",
    fill: "#174295"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1754",
    "data-name": "Rectangle 1754",
    width: 2.365,
    height: 4.138,
    transform: "translate(10.312 18.6) rotate(-45)",
    fill: "#174295"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1775",
    "data-name": "Rectangle 1775",
    width: 2.365,
    height: 7.965,
    transform: "translate(17.888 21.757) rotate(-47)",
    fill: "#ff0e0e"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowSoc);
export default __webpack_public_path__ + "static/media/Low_SOC.b6f3412e722f3e914e270c66b0569b67.svg";
export { ForwardRef as ReactComponent };